export default "__VITE_ASSET__eabf8359__"